import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Switch, Link, BrowserRouter as Router, Route } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { mainListItems } from "./listItems";
import Chart from "./Chart";
import Summary from "./Summary";
import Users from "./Users";
import Videos from "./Videos";
import AddVideo from "./AddVideo";
import { useAuth } from "../../context/AuthContext";
import firestore from "../../firebase.config";
import Avatar from "@material-ui/core/Avatar";
import alarm from "../../img/alarm.png";

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {"Copyright © "}
            <Link color="inherit" href="/">
                VLearnAI
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
        </Typography>
    );
}

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "0 8px",
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        align: "center",
    },
    menuButtonHidden: {
        display: "none",
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: "relative",
        whiteSpace: "nowrap",
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: "hidden",
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: "100vh",
        overflow: "auto",
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
    },
    fixedHeight: {
        height: 240,
    },
    alterRoot: {
        height: "80vh",
        color: "red",
    },
}));

export default function AdminDashboard() {
    const classes = useStyles();
    const { currentUser } = useAuth();
    const [loggedUser, setLoggedUser] = useState();
    const [open, setOpen] = React.useState(true);

    useEffect(() => {
        const getUserDetail = async (uID) => {
            const userRef = await firestore.collection("users").doc(uID).get();
            const data = userRef.data();
            console.log(currentUser);
            setLoggedUser(data);
        };

        console.log(currentUser);

        getUserDetail(currentUser.uid);
    }, []);

    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

    return (
        <>
            <Router>
                {loggedUser && loggedUser.role === "admin" ? (
                    <div className={classes.root}>
                        <CssBaseline />
                        <Drawer
                            variant="permanent"
                            classes={{
                                paper: clsx(
                                    classes.drawerPaper,
                                    !open && classes.drawerPaperClose
                                ),
                            }}
                            open={open}
                        >
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="open drawer"
                                onClick={handleDrawerOpen}
                                className={clsx(
                                    classes.menuButton,
                                    open && classes.menuButtonHidden
                                )}
                            >
                                <MenuIcon />
                            </IconButton>
                            <div
                                className={clsx(
                                    classes.toolbarIcon,
                                    !open && classes.menuButtonHidden
                                )}
                            >
                                <IconButton onClick={handleDrawerClose}>
                                    <ChevronLeftIcon />
                                </IconButton>
                            </div>

                            <Divider />
                            <List>{mainListItems}</List>
                        </Drawer>

                        <main className={classes.content}>
                            <Container
                                maxWidth="lg"
                                className={classes.container}
                            >
                                <Grid item xs={12}>
                                    <Paper className={classes.paper}>
                                        <Route exact path="/admindashboard">
                                            <Grid container spacing={3}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    md={8}
                                                    lg={9}
                                                >
                                                    <Paper
                                                        className={
                                                            fixedHeightPaper
                                                        }
                                                    >
                                                        <Chart />
                                                    </Paper>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    md={4}
                                                    lg={3}
                                                >
                                                    <Paper
                                                        className={
                                                            fixedHeightPaper
                                                        }
                                                    >
                                                        <Summary />
                                                    </Paper>
                                                </Grid>
                                            </Grid>
                                        </Route>
                                        <Route
                                            exact
                                            path="/manage-users"
                                            component={Users}
                                        ></Route>
                                        <Route exact path="/manage-videos">
                                            <Videos />
                                            <AddVideo />
                                        </Route>
                                    </Paper>
                                </Grid>
                            </Container>
                            <Box pb={5}>
                                <Copyright />
                            </Box>
                        </main>
                    </div>
                ) : (
                    <Grid container spacing={3} className={classes.alterRoot}>
                        <Grid
                            item
                            xs={12}
                            container
                            spacing={0}
                            align="center"
                            justify="center"
                            direction="column"
                        >
                            <Typography component="h1" variant="h1">
                                <Avatar
                                    alt="alarm"
                                    style={{ height: "80px", width: "80px" }}
                                    variant="square"
                                    src={alarm}
                                />
                                Opps!
                            </Typography>
                            <Typography variant="h6">
                                You are not authorized to access this page
                            </Typography>
                            <Box mt={2}>
                                <Button
                                    component={Link}
                                    to="/"
                                    style={{ textDecoration: "none" }}
                                >
                                    Go Back
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                )}
            </Router>
        </>
    );
}
